import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import NotificationWizardModal from './tutorials/NotificationWizardModal';
const t = key => app.translator.trans('nagusi-tutorials.forum.tutorials.' + key).toString();
export default () => {
  const clubSlug = app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
  const showDonations = app.forum.attribute('nagusiMatchRatingsEnableDonations') !== false;
  const sections = [{
    id: 'pwa',
    slug: 'como-instalar-app-movil',
    title: t('pwa.title'),
    icon: 'fas fa-mobile-alt',
    description: t('pwa.description'),
    keywords: 'pwa, instalar, movil, app, nativa, android, ios, pantalla inicio',
    fullText: t('pwa.intro'),
    content: () => m("div", {
      className: "HelpContent"
    }, m("p", null, t('pwa.intro')), m("div", {
      className: "TutorialSteps TutorialSteps--pwa"
    }, m("div", {
      className: "TutorialStep"
    }, m("div", {
      className: "StepNumber"
    }, "1"), m("div", {
      className: "StepContent"
    }, m("h3", null, t('pwa.step1_title')), m("p", null, t('pwa.step1_text')), m("div", {
      className: "TutorialImage"
    }, m("img", {
      src: app.forum.attribute('apiUrl') + '/nagusi/tutorials/assets/pwa-install1.webp',
      alt: "PWA Paso 1"
    })))), m("div", {
      className: "TutorialStep"
    }, m("div", {
      className: "StepNumber"
    }, "2"), m("div", {
      className: "StepContent"
    }, m("h3", null, t('pwa.step2_title')), m("p", null, t('pwa.step2_text')), m("div", {
      className: "TutorialImage"
    }, m("img", {
      src: app.forum.attribute('apiUrl') + '/nagusi/tutorials/assets/pwa-install2.webp',
      alt: "PWA Paso 2"
    })))), m("div", {
      className: "TutorialStep"
    }, m("div", {
      className: "StepNumber"
    }, "3"), m("div", {
      className: "StepContent"
    }, m("h3", null, t('pwa.step3_title')), m("p", null, t('pwa.step3_text')), m("div", {
      className: "TutorialImage"
    }, m("img", {
      src: app.forum.attribute('apiUrl') + '/nagusi/tutorials/assets/pwa-install3.webp',
      alt: "PWA Paso 3"
    }))))))
  }, {
    id: 'interface-desktop',
    slug: 'guia-interfaz-ordenador',
    title: t('interface_desktop.title'),
    icon: 'fas fa-desktop',
    description: t('interface_desktop.description'),
    keywords: 'interfaz, ordenador, escritorio, menu, barra lateral, buscador, ayuda, modo oscuro',
    fullText: t('interface_desktop.intro'),
    content: () => m("div", {
      className: "HelpContent"
    }, m("p", null, t('interface_desktop.intro')), m("article", {
      className: "TutorialStep"
    }, m("h3", null, t('interface_desktop.overview')), m("div", {
      className: "TutorialImage"
    }, m("img", {
      src: app.forum.attribute('apiUrl') + '/nagusi/tutorials/assets/gui_desktop.png',
      alt: "Interfaz Desktop"
    }))), m("div", {
      className: "TutorialSteps"
    }, m("div", {
      className: "TutorialStep"
    }, m("h3", null, t('interface_desktop.top_bar')), m("ul", null, m("li", null, m("strong", null, t('interface_desktop.top_bar_logo').toString().split(':')[0], ":"), t('interface_desktop.top_bar_logo').toString().split(':')[1]), m("li", null, m("strong", null, t('interface_desktop.top_bar_search').toString().split(':')[0], ":"), t('interface_desktop.top_bar_search').toString().split(':')[1]), m("li", null, m("strong", null, t('interface_desktop.top_bar_mode').toString().split(':')[0], ":"), t('interface_desktop.top_bar_mode').toString().split(':')[1]), m("li", null, m("strong", null, t('interface_desktop.top_bar_help').toString().split(':')[0], ":"), t('interface_desktop.top_bar_help').toString().split(':')[1]))), m("div", {
      className: "TutorialStep"
    }, m("h3", null, t('interface_desktop.side_bar')), m("ul", null, m("li", null, m("strong", null, t('interface_desktop.side_bar_create').toString().split(':')[0], ":"), t('interface_desktop.side_bar_create').toString().split(':')[1]), m("li", null, m("strong", null, t('interface_desktop.side_bar_discussions').toString().split(':')[0], ":"), t('interface_desktop.side_bar_discussions').toString().split(':')[1]), m("li", null, m("strong", null, t('interface_desktop.side_bar_colabs').toString().split(':')[0], ":"), t('interface_desktop.side_bar_colabs').toString().split(':')[1]), m("li", null, m("strong", null, t('interface_desktop.side_bar_tags').toString().split(':')[0], ":"), t('interface_desktop.side_bar_tags').toString().split(':')[1])))))
  }, {
    id: 'interface-mobile',
    slug: 'guia-interfaz-movil',
    title: t('interface_mobile.title'),
    icon: 'fas fa-mobile',
    description: t('interface_mobile.description'),
    keywords: 'interfaz, movil, smartphone, menu lateral, hamburguesa, notificaciones, buscador movil',
    fullText: t('interface_mobile.intro'),
    content: () => m("div", {
      className: "HelpContent"
    }, m("p", null, t('interface_mobile.intro')), m("article", {
      className: "TutorialStep"
    }, m("h3", null, t('interface_mobile.nav_mobile')), m("div", {
      className: "TutorialImage"
    }, m("img", {
      src: app.forum.attribute('apiUrl') + '/nagusi/tutorials/assets/gui_mobile.png',
      alt: "Interfaz M\xF3vil"
    }))), m("div", {
      className: "TutorialSteps"
    }, m("div", {
      className: "TutorialStep"
    }, m("h3", null, t('interface_mobile.menu_title')), m("ul", null, m("li", null, m("strong", null, t('interface_mobile.menu_hamburger').toString().split(':')[0], ":"), t('interface_mobile.menu_hamburger').toString().split(':')[1]), m("li", null, m("strong", null, t('interface_mobile.menu_selector').toString().split(':')[0], ":"), t('interface_mobile.menu_selector').toString().split(':')[1]))), m("div", {
      className: "TutorialStep"
    }, m("h3", null, t('interface_mobile.quick_actions')), m("ul", null, m("li", null, m("strong", null, t('interface_mobile.action_search').toString().split(':')[0], ":"), t('interface_mobile.action_search').toString().split(':')[1]), m("li", null, m("strong", null, t('interface_mobile.action_bell').toString().split(':')[0], ":"), t('interface_mobile.action_bell').toString().split(':')[1]), m("li", null, m("strong", null, t('interface_mobile.action_avatar').toString().split(':')[0], ":"), t('interface_mobile.action_avatar').toString().split(':')[1]), m("li", null, m("strong", null, t('interface_mobile.action_edit').toString().split(':')[0], ":"), t('interface_mobile.action_edit').toString().split(':')[1])))))
  }, {
    id: 'profile',
    slug: 'perfil-y-configuracion-usuario',
    title: t('profile.title'),
    icon: 'fas fa-user-edit',
    description: t('profile.description'),
    keywords: 'perfil, avatar, firma, configuracion, contraseña, email, modo oscuro, seguridad',
    fullText: t('profile.intro'),
    content: () => m("div", {
      className: "HelpContent"
    }, m("p", null, t('profile.intro')), m("div", {
      className: "TutorialSteps"
    }, m("div", {
      className: "TutorialStep"
    }, m("div", {
      className: "StepContent"
    }, m("h3", null, t('profile.access')), m("p", null, m("strong", null, t('profile.access_desktop').toString().split(':')[0], ":"), t('profile.access_desktop').toString().split(':')[1]), m("div", {
      className: "TutorialImage"
    }, m("img", {
      src: app.forum.attribute('apiUrl') + '/nagusi/tutorials/assets/profile_desktop.webp',
      alt: "ProfileDesktop"
    })), m("p", null, m("strong", null, t('profile.access_mobile').toString().split(':')[0], ":"), t('profile.access_mobile').toString().split(':')[1]), m("div", {
      className: "TutorialImage"
    }, m("img", {
      src: app.forum.attribute('apiUrl') + '/nagusi/tutorials/assets/profile_mobile.webp',
      alt: "ProfileMobile"
    })))), m("div", {
      className: "TutorialStep"
    }, m("div", {
      className: "StepContent"
    }, m("h3", null, t('profile.sections')), m("ul", null, m("li", null, m("strong", null, t('profile.section_posts').toString().split(':')[0], ":"), t('profile.section_posts').toString().split(':')[1]), m("li", null, m("strong", null, t('profile.section_likes').toString().split(':')[0], ":"), t('profile.section_likes').toString().split(':')[1]), m("li", null, m("strong", null, t('profile.section_players').toString().split(':')[0], ":"), t('profile.section_players').toString().split(':')[1]), m("li", null, m("strong", null, t('profile.section_signature').toString().split(':')[0], ":"), t('profile.section_signature').toString().split(':')[1]), m("li", null, m("strong", null, t('profile.section_settings').toString().split(':')[0], ":"), t('profile.section_settings').toString().split(':')[1]), m("li", null, m("strong", null, t('profile.section_security').toString().split(':')[0], ":"), t('profile.section_security').toString().split(':')[1])))), m("div", {
      className: "TutorialStep"
    }, m("div", {
      className: "StepContent"
    }, m("h3", null, t('profile.section_settings').toString().split(':')[0]), m("ul", null, t('profile.settings_items').split('|').map(item => m("li", null, item)))))))
  }, {
    id: 'games',
    slug: 'juegos-concursos-y-valoraciones',
    title: t('games.title'),
    icon: 'fas fa-trophy',
    description: t('games.description'),
    keywords: 'juegos, concursos, 11 aldeanos, bolilla, porra, valoraciones, ranking, trofeo aa, puntos',
    fullText: t('games.description'),
    content: () => {
      const gamesRoute = app.routes.aurreraJokoak ? app.route('aurreraJokoak') : '/la-bolilla/2025-2026/clasificacion';
      return m("div", {
        className: "HelpContent GamesHelp"
      }, m("p", {
        className: "GamesIntro",
        style: "font-size: 1.1em; line-height: 1.6; margin-bottom: 20px; color: var(--muted-control-color);"
      }, t('games.intro_text')), m("div", {
        className: "Action-Buttons",
        style: "margin-bottom: 30px;"
      }, m("a", {
        href: gamesRoute,
        className: "Button Button--primary Action-Link GoToGamesButton",
        style: "background: #e11d48; border-color: #e11d48; font-weight: bold; padding: 10px 20px; font-size: 1.1em; display: inline-flex; align-items: center; gap: 8px;"
      }, m("i", {
        className: "fas fa-gamepad"
      }), " ", t('games.go_to_games'))), m("div", {
        className: "GamesContainer",
        style: "display: flex; flex-direction: column; gap: 30px;"
      }, m("section", {
        className: "GameSection",
        style: "background: rgba(0,0,0,0.02); padding: 25px; border-radius: 12px; border-left: 4px solid #ff2523;"
      }, m("h3", {
        style: "margin-top: 0; color: #ff2523; font-size: 1.4em; display: flex; align-items: center; gap: 10px;"
      }, m("i", {
        className: "fas fa-futbol"
      }), " ", t('games.bolilla')), m("p", {
        style: "font-size: 1.05em; line-height: 1.5;"
      }, t('games.bolilla_text')), m("div", {
        className: "Contest-Scoring",
        style: "margin-top: 15px; background: rgba(255,255,255,0.6); padding: 15px; border-radius: 8px;"
      }, m("ul", {
        style: "margin: 0; padding-left: 20px; display: flex; flex-direction: column; gap: 8px;"
      }, t('games.bolilla_scoring').split('|').map(item => m("li", null, m.trust(item.toString()))))), m("div", {
        className: "Action-Buttons",
        style: "margin-top: 15px;"
      }, m("a", {
        href: "/la-bolilla/2025-2026/clasificacion",
        className: "Button Button--secondary Action-Link"
      }, m("i", {
        className: "fas fa-trophy",
        style: "margin-right: 6px; color: #ffd700;"
      }), " ", t('games.ranking_button')))), m("section", {
        className: "GameSection",
        style: "background: rgba(0,0,0,0.02); padding: 25px; border-radius: 12px; border-left: 4px solid #4caf50;"
      }, m("h3", {
        style: "margin-top: 0; color: #4caf50; font-size: 1.4em; display: flex; align-items: center; gap: 10px;"
      }, m("i", {
        className: "fas fa-shield-alt"
      }), " ", t('games.contest_11a')), m("p", {
        style: "font-size: 1.05em; line-height: 1.5;"
      }, m.trust(t('games.contest_11a_text').toString())), m("div", {
        className: "Contest-Rules",
        style: "margin-top: 15px; background: rgba(255,255,255,0.6); padding: 15px; border-radius: 8px;"
      }, m("ul", {
        style: "margin: 0; padding-left: 20px; display: flex; flex-direction: column; gap: 8px;"
      }, t('games.contest_rules').split('|').map(item => m("li", null, m.trust(item.toString()))))), m("div", {
        className: "Action-Buttons",
        style: "margin-top: 15px;"
      }, m("a", {
        href: "/11-aldeanos/2025-2026/clasificacion",
        className: "Button Button--secondary Action-Link"
      }, m("i", {
        className: "fas fa-list-ol",
        style: "margin-right: 6px;"
      }), " ", t('games.ranking_button')))), m("section", {
        className: "GameSection",
        style: "background: rgba(0,0,0,0.02); padding: 25px; border-radius: 12px; border-left: 4px solid #673ab7;"
      }, m("h3", {
        style: "margin-top: 0; color: #673ab7; font-size: 1.4em; display: flex; align-items: center; gap: 10px;"
      }, m("i", {
        className: "fas fa-star"
      }), " ", t('games.ratings')), m("p", {
        style: "font-size: 1.05em; line-height: 1.5;"
      }, m.trust(t('games.ratings_text1').toString())), m("p", {
        style: "font-size: 1.05em; line-height: 1.5;"
      }, m.trust(t('games.ratings_text2').toString())), m("div", {
        className: "Action-Buttons",
        style: "margin-top: 15px;"
      }, m("a", {
        href: "/valoracion-".concat(clubSlug, "/2025-2026/clasificacion"),
        className: "Button Button--primary Action-Link",
        style: "background: #673ab7; border-color: #673ab7;"
      }, m("i", {
        className: "fas fa-chart-line",
        style: "margin-right: 6px;"
      }), " ", t('games.ranking_button')))), m("section", {
        className: "GameSection",
        style: "background: rgba(0,0,0,0.02); padding: 25px; border-radius: 12px; border-left: 4px solid #00bcd4;"
      }, m("h3", {
        style: "margin-top: 0; color: #00bcd4; font-size: 1.4em; display: flex; align-items: center; gap: 10px;"
      }, m("i", {
        className: "fas fa-award"
      }), " ", t('games.achievements')), m("p", {
        style: "font-size: 1.05em; line-height: 1.5;"
      }, t('games.achievements_text1')), m("p", {
        style: "font-size: 1.05em; line-height: 1.5;"
      }, t('games.achievements_text2')), m("div", {
        className: "Action-Buttons",
        style: "margin-top: 15px;"
      }, m("a", {
        href: "/clasificacion-logros",
        className: "Button Button--secondary Action-Link"
      }, m("i", {
        className: "fas fa-medal",
        style: "margin-right: 6px; color: #00bcd4;"
      }), " ", t('games.achievements_button'))))));
    }
  }, {
    id: 'messages',
    slug: 'como-enviar-mensajes-privados',
    title: t('messages.title'),
    icon: 'fas fa-envelope',
    description: t('messages.description'),
    keywords: 'messages, privados, chat, directos, destinatarios, comunicacion',
    fullText: t('messages.intro'),
    content: () => m("div", {
      className: "HelpContent"
    }, m("p", null, t('messages.intro')), m("div", {
      className: "TutorialSteps TutorialSteps--full"
    }, m("div", {
      className: "TutorialStep"
    }, m("div", {
      className: "StepContent"
    }, m("h3", null, t('messages.start_chat')), m("ul", null, m("li", null, m("strong", null, t('messages.from_menu').toString().split(':')[0], ":"), t('messages.from_menu').toString().split(':')[1]), m("li", null, m("strong", null, t('messages.from_profile').toString().split(':')[0], ":"), t('messages.from_profile').toString().split(':')[1])), m("div", {
      className: "Alert-Info"
    }, m("i", {
      className: "fas fa-info-circle"
    }), m("p", null, m.trust(t('messages.recipients_alert').toString()))), m("h3", null, t('messages.manage_messages')), m("p", null, t('messages.manage_text'))))))
  }, {
    id: 'notifications',
    slug: 'notificaciones-y-seguimiento-temas',
    title: t('notifications.title'),
    icon: 'fas fa-bell',
    description: t('notifications.description'),
    keywords: 'notificaciones, alertas, seguimiento, temas, push, email, campana',
    fullText: t('notifications.intro'),
    content: () => m("div", {
      className: "HelpContent"
    }, m("p", null, t('notifications.intro')), m("div", {
      className: "Action-Buttons",
      style: "margin: 20px 0 30px 0;"
    }, m(Button, {
      className: "Button Button--primary Action-Link",
      style: "background: #ee2523; border-color: #ee2523; font-weight: bold; padding: 12px 22px; font-size: 1.05em; display: inline-flex; align-items: center; gap: 8px; border-radius: 12px; box-shadow: 0 4px 14px rgba(238, 37, 35, 0.25);",
      onclick: () => app.modal.show(NotificationWizardModal)
    }, m("i", {
      className: "fas fa-magic"
    }), " ", app.translator.trans('nagusi-tutorials.forum.notifications_wizard.hero_title') || 'Abrir Asistente Interactivo de Notificaciones')), m("div", {
      className: "TutorialSteps TutorialSteps--pwa"
    }, m("div", {
      className: "TutorialStep"
    }, m("div", {
      className: "StepContent"
    }, m("h3", null, t('notifications.types')), m("ul", null, m("li", null, m("strong", null, t('notifications.type_web').toString().split(':')[0], ":"), t('notifications.type_web').toString().split(':')[1]), m("li", null, m("strong", null, t('notifications.type_push').toString().split(':')[0], ":"), t('notifications.type_push').toString().split(':')[1]), m("li", null, m("strong", null, t('notifications.type_email').toString().split(':')[0], ":"), t('notifications.type_email').toString().split(':')[1])), m("p", null, m.trust(t('notifications.customize_text').toString())))), m("div", {
      className: "TutorialStep"
    }, m("div", {
      className: "TutorialImage"
    }, m("img", {
      src: app.forum.attribute('apiUrl') + '/nagusi/tutorials/assets/configure_notifications.webp',
      alt: "Configurar notificaciones"
    })))), m("section", {
      style: "margin-top: 30px;"
    }, m("h3", null, t('notifications.follow_topics')), m("p", null, m.trust(t('notifications.follow_text').toString()))))
  }, {
    id: 'editor',
    slug: 'guia-editor-y-subir-imagenes',
    title: t('editor.title'),
    icon: 'fas fa-pen-nib',
    description: t('editor.description'),
    keywords: 'editor, fotos, imagenes, video, youtube, twitter, alineaciones, formato',
    fullText: t('editor.intro'),
    content: () => m("div", {
      className: "HelpContent"
    }, m("p", null, t('editor.intro')), m("div", {
      className: "TutorialSteps TutorialSteps--full"
    }, m("div", {
      className: "TutorialStep"
    }, m("div", {
      className: "StepContent"
    }, m("h3", null, t('editor.toolbar')), m("ul", null, m("li", null, m("strong", null, t('editor.tool_format').toString().split(':')[0], ":"), t('editor.tool_format').toString().split(':')[1]), m("li", null, m("strong", null, t('editor.tool_media').toString().split(':')[0], ":"), t('editor.tool_media').toString().split(':')[1]), m("li", null, m("strong", null, t('editor.tool_lineups').toString().split(':')[0], ":"), t('editor.tool_lineups').toString().split(':')[1]), m("li", null, m("strong", null, t('editor.tool_images').toString().split(':')[0], ":"), t('editor.tool_images').toString().split(':')[1])), m("p", null, m("strong", null, t('editor.seo_text').toString().split(':')[0], ":"), t('editor.seo_text').toString().split(':')[1])))))
  }, {
    id: 'security',
    slug: 'normas-comunidad-y-seguridad',
    title: t('security.title'),
    icon: 'fas fa-shield-alt',
    description: t('security.description'),
    keywords: 'normas, seguridad, reportar, ignorar, bloquear, contraseña, sesiones',
    fullText: t('security.intro'),
    content: () => m("div", {
      className: "HelpContent"
    }, m("p", null, t('security.intro')), m("div", {
      className: "TutorialSteps"
    }, m("div", {
      className: "TutorialStep"
    }, m("div", {
      className: "StepContent"
    }, m("h3", null, t('security.report')), m("p", null, m.trust(t('security.report_text').toString())))), m("div", {
      className: "TutorialStep"
    }, m("div", {
      className: "StepContent"
    }, m("h3", null, t('security.security')), m("p", null, m.trust(t('security.security_text').toString()))))))
  }, {
    id: 'funding',
    slug: "ayuda-aurrera-".concat(clubSlug),
    title: t('funding.title'),
    icon: 'fas fa-hands-helping',
    description: t('funding.description'),
    keywords: 'financiacion, amazon, afiliados, kofi, ko-fi, cafe, donacion, colaborar, ayuda, servidor, ia',
    fullText: t('funding.intro_seo'),
    content: () => m("div", {
      className: "HelpContent FundingHelp"
    }, m("p", {
      className: "FundingIntro"
    }, t('funding.intro')), m("div", {
      className: "FundingGrid"
    }, m("div", {
      className: "FundingCard AmazonCard"
    }, m("div", {
      className: "FundingCard-header"
    }, m("i", {
      className: "fab fa-amazon BrandIcon"
    }), m("h3", null, t('funding.amazon_title'))), m("div", {
      className: "FundingCard-body"
    }, m("p", null, t('funding.amazon_text_1')), m("p", null, t('funding.amazon_text_2')), m("div", {
      className: "CommissionsLink"
    }, m("a", {
      href: "https://afiliados.amazon.es/help/operating/schedule",
      target: "_blank",
      rel: "noopener noreferrer"
    }, m("i", {
      className: "fas fa-table"
    }), " ", t('funding.amazon_table_link')))), m("div", {
      className: "FundingCard-footer"
    }, m("a", {
      href: "https://amzn.to/4vhanSg",
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--primary PurchaseButton"
    }, m("i", {
      className: "fas fa-shopping-cart"
    }), " ", t('funding.amazon_button')))), m("div", {
      className: "FundingCard KofiCard"
    }, m("div", {
      className: "FundingCard-header"
    }, m("i", {
      className: "fas fa-coffee BrandIcon"
    }), m("h3", null, t('funding.kofi_title'))), m("div", {
      className: "FundingCard-body"
    }, m("p", null, t('funding.kofi_text'))), m("div", {
      className: "FundingCard-footer"
    }, m("a", {
      href: "https://ko-fi.com/aurreraathletic",
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--primary KofiButton"
    }, m("i", {
      className: "fas fa-heart"
    }), " ", t('funding.kofi_button')))), m("div", {
      className: "FundingCard FutureCard"
    }, m("div", {
      className: "FundingCard-header"
    }, m("i", {
      className: "fas fa-rocket BrandIcon"
    }), m("h3", null, t('funding.future_title'))), m("div", {
      className: "FundingCard-body"
    }, m("p", null, t('funding.future_text')), m("div", {
      className: "FutureBadge"
    }, m("span", {
      className: "PulseBeacon"
    }), " ", t('funding.future_badge'))))))
  }, {
    id: 'shortcodes',
    slug: 'comandos-rapidos-ampersand',
    title: t('shortcodes.title'),
    icon: 'fas fa-keyboard',
    description: t('shortcodes.description'),
    keywords: 'comandos, ampersand, clasificacion, tabla, partidos, resultados, proximo, ultimo, ayuda, editor',
    fullText: t('shortcodes.intro'),
    content: () => m("div", {
      className: "HelpContent"
    }, m("p", null, t('shortcodes.intro')), m("div", {
      className: "TutorialSteps"
    }, m("div", {
      className: "TutorialStep"
    }, m("h3", null, t('shortcodes.how_to_use')), m("p", null, m.trust(t('shortcodes.how_to_use_text').toString()))), m("div", {
      className: "TutorialStep"
    }, m("h3", null, t('shortcodes.list_commands')), m("ul", null, m("li", null, m("strong", null, "&clasificacion / &tabla [equipo] [temporada]:"), " ", t('shortcodes.cmd_clasificacion')), m("li", null, m("strong", null, "&proximo / &proximos / &sig [equipo] [temporada] [numero]:"), " ", t('shortcodes.cmd_proximo')), m("li", null, m("strong", null, "&ultimo / &ultimos / &ant [equipo] [temporada] [numero]:"), " ", t('shortcodes.cmd_ultimo')))), m("div", {
      className: "TutorialStep"
    }, m("h3", null, t('shortcodes.teams_title')), m("p", null, t('shortcodes.teams_intro')), m("ul", null, m("li", null, m("code", null, "athletic-club")), m("li", null, m("code", null, "athletic-club-femenino"), " o ", m("code", null, "femenino")), m("li", null, m("code", null, "bilbao-athletic"), " o ", m("code", null, "filial")), m("li", null, m("code", null, "basconia")))), m("div", {
      className: "TutorialStep"
    }, m("h3", null, t('shortcodes.autocomplete_title')), m("p", null, t('shortcodes.autocomplete_text')))))
  }, {
    id: 'ignore',
    slug: 'como-funciona-boton-ignorar',
    title: t('ignore.title'),
    icon: 'fas fa-user-slash',
    description: t('ignore.description'),
    keywords: 'ignorar, ignorar usuario, ignorado total, ignorado parcial, bloquear, ocultar posts, notificaciones ignorar',
    fullText: t('ignore.intro'),
    content: () => m("div", {
      className: "HelpContent IgnoreHelpContent"
    }, m("p", null, t('ignore.intro')), m("div", {
      className: "HelpPage-steps-card",
      style: "background: rgba(0,0,0,0.02); padding: 30px; border-radius: 15px; border: 1px dashed rgba(238, 61, 47, 0.3); margin: 30px 0;"
    }, m("h3", {
      style: "margin-top: 0; font-size: 1.3em; display: flex; align-items: center; gap: 10px; margin-bottom: 20px; color: var(--heading-color);"
    }, m("i", {
      className: "fas fa-directions",
      style: "color: #ee3d2f;"
    }), " ", t('ignore.how_to_title')), m("div", {
      className: "HelpPage-steps-grid",
      style: "display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 20px;"
    }, m("div", {
      className: "step-column",
      style: "background: var(--body-bg); padding: 20px; border-radius: 10px; border: 1px solid var(--control-bg);"
    }, m("h4", {
      style: "margin-top: 0; font-size: 1.1em; display: flex; align-items: center; gap: 8px; margin-bottom: 10px; color: var(--heading-color);"
    }, m("i", {
      className: "fas fa-desktop",
      style: "color: #ee3d2f;"
    }), " ", t('ignore.desktop_title')), m("p", {
      style: "margin: 0; font-size: 0.9em; line-height: 1.5; color: var(--text-color);"
    }, t('ignore.desktop_steps'))), m("div", {
      className: "step-column",
      style: "background: var(--body-bg); padding: 20px; border-radius: 10px; border: 1px solid var(--control-bg);"
    }, m("h4", {
      style: "margin-top: 0; font-size: 1.1em; display: flex; align-items: center; gap: 8px; margin-bottom: 10px; color: var(--heading-color);"
    }, m("i", {
      className: "fas fa-mobile-alt",
      style: "color: #ee3d2f;"
    }), " ", t('ignore.mobile_title')), m("p", {
      style: "margin: 0; font-size: 0.9em; line-height: 1.5; color: var(--text-color);"
    }, t('ignore.mobile_steps'))))), m("div", {
      className: "HelpPage-grid",
      style: "display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 20px; margin-top: 30px;"
    }, m("section", {
      className: "HelpPage-section partial",
      style: "background: rgba(0,0,0,0.02); padding: 25px; border-radius: 12px; border-left: 4px solid #4CAF50;"
    }, m("h3", {
      style: "margin-top: 0; color: #4CAF50; font-size: 1.25em; display: flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-comment-slash"
    }), " ", t('ignore.partial_title')), m("p", {
      className: "description",
      style: "font-size: 0.95em; color: var(--muted-color); margin-bottom: 15px;"
    }, t('ignore.partial_desc')), m("ul", {
      className: "features",
      style: "list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 10px; font-size: 0.9em;"
    }, m("li", null, m("i", {
      className: "fas fa-check",
      style: "color: #4CAF50;"
    }), " ", t('ignore.partial_item1')), m("li", null, m("i", {
      className: "fas fa-check",
      style: "color: #4CAF50;"
    }), " ", t('ignore.partial_item2')), m("li", null, m("i", {
      className: "fas fa-check",
      style: "color: #4CAF50;"
    }), " ", t('ignore.partial_item3')))), m("section", {
      className: "HelpPage-section total",
      style: "background: rgba(0,0,0,0.02); padding: 25px; border-radius: 12px; border-left: 4px solid #ee3d2f;"
    }, m("h3", {
      style: "margin-top: 0; color: #ee3d2f; font-size: 1.25em; display: flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-user-secret"
    }), " ", t('ignore.total_title')), m("p", {
      className: "description",
      style: "font-size: 0.95em; color: var(--muted-color); margin-bottom: 15px;"
    }, t('ignore.total_desc')), m("ul", {
      className: "features",
      style: "list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 10px; font-size: 0.9em;"
    }, m("li", null, m("i", {
      className: "fas fa-check",
      style: "color: #4CAF50;"
    }), " ", t('ignore.total_item1')), m("li", null, m("i", {
      className: "fas fa-check",
      style: "color: #4CAF50;"
    }), " ", t('ignore.total_item2')), m("li", null, m("i", {
      className: "fas fa-check",
      style: "color: #4CAF50;"
    }), " ", t('ignore.total_item3')), m("li", null, m("i", {
      className: "fas fa-check",
      style: "color: #4CAF50;"
    }), " ", t('ignore.total_item4')), m("li", null, m("i", {
      className: "fas fa-check",
      style: "color: #4CAF50;"
    }), " ", t('ignore.total_item5'))))))
  }];
  return showDonations ? sections : sections.filter(s => s.id !== 'funding');
};